module.exports = __webpack_public_path__ + "static/media/heart-rate.d38bb059.svg";